import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const MailIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-mail${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M2 4.66668C2 4.31305 2.14048 3.97392 2.39052 3.72387C2.64057 3.47382 2.97971 3.33334 3.33333 3.33334H12.6667C13.0203 3.33334 13.3594 3.47382 13.6095 3.72387C13.8595 3.97392 14 4.31305 14 4.66668V11.3333C14 11.687 13.8595 12.0261 13.6095 12.2762C13.3594 12.5262 13.0203 12.6667 12.6667 12.6667H3.33333C2.97971 12.6667 2.64057 12.5262 2.39052 12.2762C2.14048 12.0261 2 11.687 2 11.3333V4.66668Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 4.66666L8 8.66666L14 4.66666"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default MailIcon;
